<div class="routed-container">
	<div class="routed-content">
		<div *ngIf="loading" class="loading-message">LOADING...</div>
		<div *ngIf="!loading" class="profile-box">
			<div *ngIf="!editName" class="flex items-center justify-center gap-2">
				<h2>{{user.name}}</h2>
				<i (click)="editName  = true" class="material-icons">create</i>
			</div>
			<!-- EDIT NAME -->

			<div *ngIf="editName" class="flex gap-2 items-center justify-center lg-mt lg-mb">
				<input type="text" #nameTag [value]="user.name" class="p-10 md-text">
				<button class="basic-btn-red" (click)="updateUser({name: nameTag.value})">Submit</button>
				<button class="basic-btn-lgt-blue" (click)="editName=false">Cancel</button>
			</div>

			<!-- END EDIT NAME -->
			<p class="email">{{user.email}}</p>
			<p *ngIf="!editVenmo" class="venmo-display">
				<span>
					<span>My Venmo: </span>
					<span *ngIf="!user.venmo">NOT SET</span>
				</span>
				<span>
					<span *ngIf="user.venmo">@{{user.venmo}}</span>
					<i (click)="editVenmo = true" class="material-icons">create</i>
				</span>
			</p>
			<div *ngIf="editVenmo" class="venmo-edit hrz-center">
				<div class="vert-center sm-px">
					<span>@<input #vTag [value]="user.venmo" type="text"></span>
				</div>
				<div class="vert-center sm-px">
					<button class="basic-btn-red" (click)="updateUser({venmo: vTag.value})">Submit</button>
				</div>
				<div class="vert-center sm-px">
					<button class="basic-btn-lgt-blue" (click)="editVenmo = false">Cancel</button>
				</div>
			</div>
		</div>
	</div>
</div>
